module.exports = __webpack_public_path__ + "static/media/email.2221bdd9.svg";